import Avatars from './Avatars.Container';

export default Avatars;
